
import {setServer} from "@/utils/axios";
const request = setServer();
// 查询员工列表
export function getStaffList(data) {
  return request({
    url: '/base/staff/list' ,
    method: 'post',
    data:data
  })
}
// 查询员工详情
export function getStaffDetail(data) {
  return request({
    url: '/base/staff/get' ,
    method: 'post',
    data:data
  })
}
// 新增员工
export function addStaff(data) {
  return request({
    url: '/base/staff/add' ,
    method: 'post',
    data:data
  })
}

// 修改员工
export function updateStaff(data) {
  return request({
    url: '/base/staff/update' ,
    method: 'post',
    data:data
  })
}

// 员工下拉
export function getStaffRefer(data) {
  return request({
    url: '/base/staff/refer' ,
    method: 'post',
    data:data
  })
}

// 员工关联下拉(已绑定)
export function getStaffRelationRefer(data) {
  return request({
    url: '/base/staff/relation/refer' ,
    method: 'post',
    data:data
  })
}

// 员工关联下拉(已绑定)
export function deleteStaff(data) {
  return request({
    url: '/base/staff/delete' ,
    method: 'post',
    data:data
  })
}

// 提交设备名
export function bindCustomerName(data) {
  return request({
    url: '/base/staff/bind/name',
    method: 'post',
    data,
    responseType:'arraybuffer'
  })
}

// 提交验证码
export function bindCustomerCode(data) {
  return request({
    url: '/base/staff/bind/code',
    method: 'post',
    data,
  })
}

// 再次提交验证码
export function regCustomerCode(data) {
  return request({
    url: '/base/staff/reg/code',
    method: 'post',
    data,
  })
}

// 检验mfa状态
export function checkMfa(data) {
  return request({
    url: '/base/staff/check/mfa',
    method: 'post',
    data,
  })
}

// 校验验证码
export function checkCode(data) {
  return request({
    url: '/base/staff/check/code',
    method: 'post',
    data,
  })
}

// 开关MFA状态
export function updateCustomerMFA(data) {
  return request({
    url: '/base/staff/update/mfa',
    method: 'post',
    data
  })
}

// 客户下拉--销售
export function getCustomerReferByStaff(data) {
  return request({
    url: '/base/staff/customer/refer/sell',
    method: 'post',
    data
  })
}

// 客户下拉--老板
export function getCustomerReferByBoss(data) {
  return request({
    url: '/base/staff/customer/refer/boss',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/base/staff.js